import { Navigate, useParams } from 'react-router-dom';

function Order() {
    const urlParams = useParams();
    return <Navigate to={`/${(urlParams as any).region}/${(urlParams as any).country}/${(urlParams as any).locale}/order/preview`} />;
}
export default Order;